import script from "./PasswordField.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordField.vue?vue&type=script&setup=true&lang=js"

import "./PasswordField.vue?vue&type=style&index=0&id=2b95bec2&lang=less"

const __exports__ = script;

export default __exports__